/* eslint-disable import/prefer-default-export */
export const MXP_CARD_MANAGEMENT_FREEZE_CARD = 'MXP_CARD_MANAGEMENT_FREEZE_CARD';
export const MXP_CARD_MANAGEMENT_ACTIVATE_CONFIRM = 'MXP_CARD_MANAGEMENT_ACTIVATE_CONFIRM';
export const MXP_CARD_MANAGEMENT_CONNECT_ACCOUNT = 'MXP_CARD_MANAGEMENT_CONNECT_ACCOUNT';

export const MXP_FC_GET_VISIT = 'MXP_FC_GET_VISIT';
export const MXP_FC_GET_CONTINUE = 'MXP_FC_GET_CONTINUE';
export const MXP_FC_REVIEW_VISIT = 'MXP_FC_REVIEW_VISIT';
export const MXP_FC_EXTEND_VISIT = 'MXP_FC_EXTEND_VISIT';
export const MXP_FC_SETTLE = 'MXP_FC_SETTLE';
export const MXP_FC_EXTEND_CONTINUE = 'MXP_FC_EXTEND_CONTINUE';
export const MXP_FC_WITHDRAW_COLLATERAL = 'MXP_FC_WITHDRAW_COLLATERAL';
